/**
 * What a board's toolbar button looks like, lit while it is doing something.
 *
 * Shared by the two boards so that "this control is in force" reads the same on
 * both. Literal classes rather than assembled ones: Tailwind generates its
 * stylesheet by scanning source text, and a class built at runtime is one that
 * is not in it.
 */
export function boardTool(chosen: boolean): string {
  return chosen
    ? 'rounded-field bg-brand-soft px-3 py-1.5 font-medium text-[13px] text-brand-strong'
    : 'rounded-field px-3 py-1.5 font-medium text-[13px] text-t2 hover:bg-line-2 hover:text-t1'
}
